import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { HelmetProvider } from 'react-helmet-async'
import reportWebVitals from './reportWebVitals'
import ReactGA from 'react-ga4'
import 'bootstrap/dist/css/bootstrap.min.css'
import './style.css'

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)

reportWebVitals()